import { RadioButton } from "Components/Form/RadioButton";
import { useTexts } from "Components/TextContext";
import { RENTAL_TYPE_VARIABLE } from "Store/interfaces/products/checkout/riskProducts/vehicleProducts/BaseCarProduct";
import { CarCoverage } from "Store/interfaces/products/coverage";
import { isDefined } from "Utils/functions";
import React from "react";

interface Props {
  readonly updatePrices: (field: string, value: string) => void;
  readonly coverage: CarCoverage;
  readonly priceIsLoading?: boolean;
}
export const RentalType = (props: Props): React.ReactElement => {
  const { getText } = useTexts();
  const { updatePrices } = props;

  return (
    <RadioButton
      id="rentalType"
      name="rentalType"
      label={getText("carform.optionlabel.rentaltype")}
      hint={getText("carform.optionhint.rentaltype")}
      onChange={(event) => {
        if (isDefined(event)) {
          updatePrices(event.target.name, event.target.value);
        }
      }}
      options={[
        {
          id: "1",
          value: RENTAL_TYPE_VARIABLE.NONE,
          label: getText("carform.optionlabel.rentaltype-none"),
        },
        {
          id: "2",
          value: RENTAL_TYPE_VARIABLE.RENTAL_TYPE_ORDINARY,
          label: getText("carform.optionlabel.rentaltype-ordinary"),
          info: getText("carform.optionhint.rentaltype-ordinary"),
        },
        {
          id: "3",
          value: RENTAL_TYPE_VARIABLE.RENTAL_TYPE_EXTENDED,
          label: getText("carform.optionlabel.rentaltype-extended"),
          info: getText("carform.optionhint.rentaltype-extended"),
        },
      ]}
    />
  );
};
